import { useMemo } from 'react';
import { useActionNodeDrop } from '../useDrop/useDrop';
import { useActionNodeMove } from '../useMove/useMove';
export function useActionHandlers({ props, state, }) {
    const onMove = useActionNodeMove({ state });
    const onDrop = useActionNodeDrop({ props, state });
    const handlers = useMemo(() => ({
        onMove,
        onDrop,
    }), [onMove, onDrop]);
    return handlers;
}
